// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.outline-card-outlineCard-X2D2X {
  border: 1px solid var(--border-color);
  border-radius: var(--large-border-radius);
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/outline-card/outline-card.module.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,yCAAyC;AAC3C","sourcesContent":[".outlineCard {\n  border: 1px solid var(--border-color);\n  border-radius: var(--large-border-radius);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"outlineCard": `outline-card-outlineCard-X2D2X`
};
export default ___CSS_LOADER_EXPORT___;
